/* eslint-disable */
import React, {useEffect, useState} from "react";
import {Button, Checkbox, Divider, Form, Input, message, Modal} from "antd";
import {useAuth} from "../../providers/AuthProvider";
import {userLogin} from "../../services/user";
import {useNavigate} from "react-router-dom";
import {md5} from "js-md5";
import {GoogleOutlined, WechatOutlined, MobileOutlined} from "@ant-design/icons";
import "./index.css";
import {baseAuthURL, baseURL} from "../../api/Request";
import {useTranslation} from "react-i18next";
import {getPhoneCode, GetTokenApi, getUserApi, loginByPhoneNumberCode} from "../../api/Api";
// import "../../wxLogin.js";
import logo from "../../static/cn_logo2.png";
import CompleteInfo from "../components/CompleteInfo";

function LoginByPhonePage() {
	const {setNewToken, userInfo} = useAuth();
	const navigate = useNavigate();
	const [disabled, setDisabled] = useState(false);
	const [countdown, setCountdown] = useState(60);
	const [visible, setVisible] = useState<boolean>(false);
	const [form] = Form.useForm();
	const handleGetCode = async () => {
		const phoneNumber = form.getFieldValue("phoneNumber"); // 获取手机号
		if (!phoneNumber) {
			message.error("请输入手机号！");
			return;
		}
		setDisabled(true);
		let timeLeft = 60;
		const timer = setInterval(() => {
			timeLeft -= 1;
			setCountdown(timeLeft);
			if (timeLeft <= 0) {
				clearInterval(timer);
				setDisabled(false);
				setCountdown(60);
			}
		}, 1000);

		try {
			const res = await getPhoneCode({phoneNumber});
			if (res) {
				message.success("验证码已发送！");
			}
		} catch (e: any) {
			message.error("验证码发送失败，请稍后再试！");
			console.log(e);
			clearInterval(timer);
			setDisabled(false);
			setCountdown(60);
		}
	};

	const getUserData = async () => {
		getUserApi()
			.then((res: object) => {
				localStorage.setItem("user", JSON.stringify(res));
			})
			.catch((e: Error) => {
				// toast.error("Failed to get user info");
				console.log(e.message);
			});
	};


	const handleSubmit = async (values: any) => {
		try {
			const res: any = await loginByPhoneNumberCode({
				phoneNumber: values?.phoneNumber,
				code: values?.code,
			});
			if (res) {
				message.success("Account login successful.");
				localStorage.setItem("token", res.accessToken);
				await getUserData();
				setNewToken(res.accessToken);
				if (!userInfo?.name) {
					showCompleteInfo()
				} else {
					navigate("/d5data");
				}
			}
		} catch (e: any) {
			message.error("Account login failed.");
			console.log(e);
		}
	};

	const onFinishFailed = (errorInfo: any) => {
		console.log("Failed:", errorInfo);
	};

	const handleOk = () => {
		setVisible(false);
	};

	const handleCancel = () => {
		setVisible(false);
	};

	const showCompleteInfo = () => {
		setVisible(true);
	};

	return (
		<div className="login-wrapper">
			{/* <div id="login_container"></div> */}
			<Modal
				// title="Basic Modal"
				open={visible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<CompleteInfo></CompleteInfo>
			</Modal>
			<div className="glow-bg-2"></div>
			<div className="login-wrapper-main">
				<div className="header">
					<img src={logo}/>
				</div>
				<div className="login-left-wrapper">
					<div className="login-left">
						<div className="login-left-top">
							<div className="login-left-top-gradient">
								欢迎使用 点灵数据搜集平台
							</div>
							<div className="login-left-top-subtitle">
								第五维度打造的点灵数据搜集平台，是一款高效数据获取工具 <br/>
								以对话的形式，提供文本、图片等数据跨模态检索，并支持互联网公开数据和私有数据部署
								<br/>
								为AI模型训练提供高质量数据
								<br/>
							</div>
						</div>
						<div className="login-left-title-wrapper">
							<video
								width="100%"
								controls
								autoPlay
								muted
								style={{
									border: "none",
									outline: "none",
									borderRadius: "10px",
								}}
							>
								<source src="../../datagptdemo.mp4" type="video/mp4"/>
								Your browser does not support the video tag.
							</video>
						</div>
					</div>
				</div>
				<div className="dlp">
					<div className="login-card-wrapper">
						<div className="login-card-wrapper-up">
							<div className="login-card-header">
								<div className="login-card-title">输入手机号和验证码</div>
								<div className="login-card-subtitle">
									欢迎登录杭州五维数据有限责任公司
								</div>
							</div>
							<Form
								form={form}
								name="basic"
								layout="vertical"
								initialValues={{remember: true}}
								onFinish={handleSubmit}
								onFinishFailed={onFinishFailed}
								autoComplete="off"
							>
								<Form.Item
									label="手机号"
									name="phoneNumber"
									rules={[
										{required: true, message: "Please input your phone number!"},
									]}
								>
									<Input style={{height: "40px", width: "95%"}}/>
								</Form.Item>

								<Form.Item label="验证码" required>
									<Input.Group compact>
										<Form.Item
											name="code"
											noStyle
											rules={[{required: true, message: "Please input your code!"}]}
										>
											<Input
												style={{height: "40px", width: "65%"}}
											/>
										</Form.Item>
										<Button
											type="primary"
											style={{height: "40px", width: "30%"}}
											onClick={handleGetCode}
											disabled={disabled}
										>
											{disabled ? `${countdown}s` : "获取验证码"}
										</Button>
									</Input.Group>
								</Form.Item>

								<Form.Item
									style={{textAlign: "center", marginTop: 30}}
								>
									<Button
										type="primary"
										htmlType="submit"
										className="submit-btn"
									>
										注册/登录
									</Button>
								</Form.Item>

								{/* <Form.Item
								name="remember"
								valuePropName="checked"
								label={null}
								style={{ marginBottom: "10px" }}
							>
								<Checkbox>记住密码</Checkbox>
							</Form.Item> */}

								<div className="login-more">
									<a href="/login">返回邮箱密码登录</a>
								</div>
							</Form>
						</div>
						<div className="login-more-confirm">
							登录即代表同意
							<a href="/docs?tab=userpolicy">《用户协议》</a>和
							<a href="/docs?tab=privacy">《产品隐私协议》</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default LoginByPhonePage;
